<script>
  import { Link } from 'svelte-navigator'
  import { createEventDispatcher } from 'svelte'
  import { _ } from 'svelte-i18n'

  import oAuthConfig from '../oauth_config.js'
  import { postO } from '../oauth.js'
  import { currentUser, clearToken, hasToken } from '../oauth.js'

  import UserShort from './UserShort.svelte'

  const dispatch = createEventDispatcher()

  async function logout() {
    await postO('/logout/')
    clearToken()
    document.location.href = '/'
  }
</script>

{#if $currentUser && $currentUser.id}
  <li class="nav-item dropdown" style="padding-top: 0; padding-bottom: 0;">
    <a
      class="nav-link dropdown-toggle"
      href={'#'}
      role="button"
      data-bs-toggle="dropdown"
      style="padding-top: 0; padding-bottom: 0;"
    >
      <UserShort user={$currentUser} />
    </a>
    <ul class="dropdown-menu dropdown-menu-end">
      <li>
        <Link
          to="/profile/"
          class="dropdown-item"
          on:click={() => {
            dispatch('linkClick')
          }}>{$_('nav.profile')}</Link
        >
      </li>
      <li>
        <button class="dropdown-item" on:click={logout}
          >{$_('nav.logout')}</button
        >
      </li>
    </ul>
  </li>
{:else if hasToken()}
  <li class="nav-item navbar-text">
    <div class="spinner-border spinner-border-sm" role="status">
      <span class="visually-hidden">{$_('generic.loading')}...</span>
    </div>
  </li>
{:else}
  <li class="nav-item dropdown">
    <a
      class="nav-link dropdown-toggle"
      href={'#'}
      role="button"
      data-bs-toggle="dropdown"
      >{$_('nav.not_loggedin')}
    </a>
    <ul class="dropdown-menu dropdown-menu-end">
      <li>
        <a class="dropdown-item" href={oAuthConfig.loginUrl}
          >{$_('nav.login')}</a
        >
      </li>
    </ul>
  </li>
{/if}
